// extracted by mini-css-extract-plugin
export default {"inputIcon":"mfr-El_7rQxS"};